import axios from 'axios';
import { wrapAxios } from '../../axios';
import { ICommonCart, ICommonAddItemToCartRequest, ICommonRemoveItemFromCartRequest } from '@cuspar/ywt.ch.model';

export const cartAPI = {
  createCartWithItem: async (request: ICommonAddItemToCartRequest, suppressError: boolean = false, timeoutMs?: number) => {
    return wrapAxios(() => axios.post<ICommonCart>(`/carts`, request, { timeout: timeoutMs }), !suppressError);
  },
  addItemToCart: async (cardId: string, request: ICommonAddItemToCartRequest, suppressError: boolean = false, timeoutMs?: number) => {
    return wrapAxios(() => axios.put<ICommonCart>(`/carts/${cardId}`, request, { timeout: timeoutMs }), !suppressError);
  },
  removeItemFromCart: async (cartId: string, request: ICommonRemoveItemFromCartRequest) => {
    return wrapAxios(() => axios.delete<ICommonCart>(`/carts/${cartId}`, { data: request }));
  },
  /**
   * The endpoint replies 200 with an empty body (not JSON null) when the user
   * has no cart, which axios surfaces as ''. Normalise it to `undefined` here so
   * no consumer ever stores a '' cart and then dereferences `cart.domains`.
   */
  getMyCart: async (suppressError: boolean = false, timeoutMs?: number) => {
    const response = await wrapAxios(() => axios.get<ICommonCart | ''>(`/carts/mycart`, { timeout: timeoutMs }), !suppressError);
    return response.success ? { success: true as const, data: response.data || undefined } : response;
  },
  getCartById: async (cartId: string) => {
    return wrapAxios(() => axios.get<ICommonCart>(`/carts/${cartId}`));
  },
  mergeLocalCart: async (cartId: string) => {
    return wrapAxios(() => axios.patch<ICommonCart>(`/carts/${cartId}/merge`));
  },
  convertToOrder: async () => {
    return wrapAxios(() => axios.post<string>(`/carts/convertToOrder`));
  },
};
